import React from "react";
import PropTypes from "prop-types";

import { CardBox } from "../CardsStyled";
import CurrentAppointment from "./CurrentAppointment";
import HistoricalAppointment from "./HistoricalAppointment";
import ShowComments from "../Global/ShowComments";
import RescheduleButton from "../Global/Reschedule";

const appointmentConfirmedCategory = "appointment_confirmed";

export const AppointmentConfirmed = ({
  isCurrent,
  description,
  moreInformation,
  appointmentProposalStart,
  appointmentProposalEnd,
  showRescheduleButton,
  enableComments
}) => {
  const showComments = enableComments && moreInformation === null;
  const isAppointmentInTheFuture =
    new Date(appointmentProposalStart) > new Date(Date.now());

  return (
    <CardBox
      data-testid="appointment-confirmation_card"
      data-category={appointmentConfirmedCategory}
    >
      {isCurrent ? (
        <>
          <CurrentAppointment
            description={description}
            rawEventDate={appointmentProposalStart}
            appointmentProposalStart={appointmentProposalStart}
            appointmentProposalEnd={appointmentProposalEnd}
          />
          {showComments && <ShowComments />}
          {showRescheduleButton && isAppointmentInTheFuture && (
            <RescheduleButton />
          )}
        </>
      ) : (
        <HistoricalAppointment
          rawEventDate={appointmentProposalStart}
          description={description}
          moreInformation={moreInformation}
        />
      )}
    </CardBox>
  );
};

AppointmentConfirmed.propTypes = {
  description: PropTypes.string.isRequired,
  moreInformation: PropTypes.string,
  isCurrent: PropTypes.bool,
  enableComments: PropTypes.bool
};

AppointmentConfirmed.defaultProps = {
  isCurrent: false
};

export default AppointmentConfirmed;
